import { format, parseISO, parse } from 'date-fns'

export const getDate = date => {
  const fullDate = format(parseISO(date), 'MMMM d')
  const splitted = fullDate.split(' ')
  return splitted
}

export const getFullDate = date => {
  const fullDate = format(parseISO(date), 'd MMM')
  return fullDate
}

export const getTime = (time, type, item) => {
  const formattedTime = time.replace('T ', '').replace(' ', '')
  if (time === null) return
  let formatted
  if (item?.attributes?.location || item?.location) {
    formatted = format(parse(formattedTime, 'HH:mm', new Date()), 'h:mm aaa')
  } else {
    formatted = format(parse(formattedTime, 'HH:mm:ss', new Date()), 'h:mm aaa')
  }
  return formatted
}
